import { baseFetch } from '../../../api/baseFetch';
import {
  AddOrgAccessToFarmResponseSchema,
  FarmOrgAccessResponseSchema,
} from './farm-orgs.schema';

export const getOrgsWithFarmAccess = (
  solarFarmId: number,
  solarFarmOrgId: number,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${solarFarmOrgId}/solar_farms/${solarFarmId}/permissions`,
    FarmOrgAccessResponseSchema.defined(),
    {
      searchParams: {
        user_type: 'org',
      },
    },
  );
};

export const addOrgAccessToFarm = (
  solarFarmId: number,
  solarFarmOrgId: number,
  orgIdToAdd: number,
  canOrgEdit: boolean,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${solarFarmOrgId}/solar_farms/${solarFarmId}/permissions`,
    AddOrgAccessToFarmResponseSchema.defined(),
    {
      method: 'POST',
      requestBody: {
        user_type: 'org',
        role_id: canOrgEdit ? 'editor' : 'viewer',
        user_id: `${orgIdToAdd}`,
      },
    },
  );
};
